import {
  AUTH_ACTIONS_CLASS,
  AUTH_CONTAINER_CLASS,
  AUTH_FIELDS_CLASS,
  AUTH_LINKS_ROW_CLASS,
  AUTH_LINK_CLASS,
  AuthPage,
  AuthPrimaryButton,
  AuthTextField,
  PasswordRequirements,
} from "@/components/auth";

import { useResetPasswordForm } from "@/hooks";
import { ReactHookFormDevelopmentTools } from "../../components/developmentTools";
import { Form, FormRootError } from "../../components/forms";
import { RouteLink } from "../../components/ui";
import { useStore } from "../../store/store";

export const ResetPassword = () => {
  const token = useStore.use.resetToken();
  const {
    form,
    form: {
      formState: { isSubmitting },
      control,
    },
    handleSubmit,
  } = useResetPasswordForm({
    defaultValues: { password: "", confirmPassword: "" },
    token: token ?? "",
  });

  return (
    <Form {...form}>
      <div className={AUTH_CONTAINER_CLASS}>
        <form
          className="grid gap-6"
          onSubmit={handleSubmit}
        >
          <AuthPage
            title="Reset Password"
            subtitle="Enter a new password that you’ll remember but others can’t guess. Enter it below to finish resetting your password."
          >
            <div className={AUTH_FIELDS_CLASS}>
              <FormRootError />

              <AuthTextField
                control={form.control}
                name="password"
                label="Password"
                inputProps={{ type: "password", placeholder: "Enter your password" }}
              />

              <AuthTextField
                control={form.control}
                name="confirmPassword"
                label="Repeat Password"
                inputProps={{ type: "password", placeholder: "Re-enter your password" }}
              />

              <PasswordRequirements />

              <div className={AUTH_ACTIONS_CLASS}>
                <AuthPrimaryButton
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  Submit
                </AuthPrimaryButton>
              </div>

              <div className={AUTH_LINKS_ROW_CLASS}>
                <RouteLink
                  to="/auth/signup"
                  className={AUTH_LINK_CLASS}
                >
                  Register
                </RouteLink>
                {" | "}
                <RouteLink
                  to="/auth/forgotPassword"
                  className={AUTH_LINK_CLASS}
                >
                  Forgot my password
                </RouteLink>
              </div>
            </div>
          </AuthPage>
        </form>

        <ReactHookFormDevelopmentTools
          // @ts-expect-error - FIXME:
          control={control}
          placement="top-left"
        />
      </div>
    </Form>
  );
};
